<template>
    <div class="layout-record-list">
        <!--s: Search 区域-->
        <div class="device-list-search">
            <h1 class="title">作业记录</h1>
            <div class="device-list-select">
                <div class="box">
                    <div class="box-list">
                        <span class="label">任务名称：</span>
                        <Input v-model="recordListParams.tasksName" clearable placeholder="任务名称" style="width: 160px" />
                    </div>
                    <div class="box-list">
                        <span class="label">执行状态：</span>
                        <Select v-model="recordListParams.status" clearable style="width: 160px">
                            <Option v-for="(status,key) in recordStatus" :value="status.value" :key="key">{{ status.label }}</Option>
                        </Select>
                    </div>
                    <div class="box-list">
                        <span class="label">引用流程：</span>
                        <Input v-model="recordListParams.flowName" clearable placeholder="引用流程" style="width: 160px" />
                    </div>
                </div>
                <div class="box">
                    <Button @click="onReset">重置</Button>
                    <Button type="primary" @click="onSearch">查询</Button>
                </div>
            </div>
        </div>
        <!--e: Search 区域-->
        <!--s: Data 区域-->
        <div class="device-list">
            <Table :loading="recordLoading" :height="deviceListHeight" :columns="recordListColumns" :data="recordListArray.content" >
                <template slot="状态" slot-scope="{ row }">
                    <font v-if="row.status === 2" class="yellow">进行中</font>
                    <font v-if="row.status === 1" class="green">已完成</font>
                    <font v-if="row.status === 0" class="grey">未完成</font>
                    <!--                        <font v-if="row.status === 2" class="red">待审批</font>-->
                </template>
                <template slot="执行人" slot-scope="{ row }">
                    <Poptip placement="bottom-start">
                        <Button class="user-item" v-if="row.executorUser"> {{ row.executorUser.userName }}</Button>
                        <template #content v-if="row.executorUser">
                            <div class="user-item-box">
                                <span class="avatar" :style="'background-image:url('+row.executorUser.profilePicture+')'"></span>
                                <div class="box-r">
                                    <span class="name">{{ row.executorUser.userName }}</span>
                                    <span class="tel">{{ row.executorUser.mobile }}</span>
                                </div>
                            </div>
                        </template>
                    </Poptip>
                    {{ !row.executorUser?'/':'' }}
                </template>
                <template slot="开始时间" slot-scope="{ row }">
                    {{ row.beginTime?row.beginTime.replace(/:..$/, '') : '/'}}
                </template>
                <template slot="更新时间" slot-scope="{ row }">
                    {{ row.updateTime?row.updateTime.replace(/:..$/, '') : '/'}}
                </template>
                <template slot="操作" slot-scope="{ row }">
                    <div class="handle">
                        <a href="javascript:" @click="onQueryLink(row)">查看</a>
                        <a href="javascript:" v-if="row.status === 1" @click="onDownLoad(row)">生成报告</a>
                        <span class="handle-grey" v-if="row.status === 0">生成报告</span>
                    </div>
                </template>
            </Table>
        </div>
        <div class="device-list-page" v-if="recordListArray.content && recordListArray.content.length !== 0">
            <Page :total="recordListArray.totalSize" :current="recordListArray.currentPage" size="small" show-total show-sizer :page-size="recordListParams.displayNumber" @on-change="onSearchPage" @on-page-size-change="onSearchPageSize"/>
        </div>
        <!--e: Data 区域-->

    </div>
</template>
<script>
import RecordInspectionList from './list'
export default RecordInspectionList
</script>
<style lang="less">
@import "list";
</style>
